import React from 'react'

var VideoLink = React.createClass({
  getInitialState: function() {
    return {view: 'button', listener: null, video: (window.Player.video || window.Player.currentVideo)}
  },
  componentDidMount: function() {
    this.setState({
      listener: window.Player.emitter.addListener('play', this.update)
    })
  },
  update: function(video){
    this.setState({
      video: video
    })
  },
  componentWillUnmount: function() {
    this.state.listener.remove()
  },
  getLink: function(){
    let baseUrl = 'https://venue.streamspot.com/';
    if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
      baseUrl = 'https://testing-venue.streamspot.com/';
    }
    if(_.isEmpty(this.state.video) || this.state.video.live){
      return baseUrl + window.Player.broadcaster.idHash
    }else{
      return baseUrl + 'video/' + this.state.video.idHash
    }
  },
  goToLink: function(){
    this.setState({
      view: 'link'
    })
  },
  render: function() {
    var link = this.getLink()
    if(this.state.view == 'button'){
      return(
        <div>
          <button onClick={this.goToLink} className='btn btn-streamspot'>Generate a Link to Share</button>
        </div>
      )
    } else{
      return(
        <div>
          <pre>{link}</pre>
        </div>
      )
    }
  }
})

var Share = React.createClass({
  handleFacebookClick: function() {
    let baseUrl = 'https://venue.streamspot.com/';
    if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
      baseUrl = 'https://testing-venue.streamspot.com/';
    }
    window.open('https://www.facebook.com/dialog/share?app_id=1528911144099853&display=popup&href='+baseUrl+window.location.search +'&redirect_uri='+baseUrl+window.location.search,'', 'width=600, height=400')
  },
  handleTwitterClick: function(){
    let baseUrl = 'https://venue.streamspot.com/';
    if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
      baseUrl = 'https://testing-venue.streamspot.com/';
    }
    window.open('https://twitter.com/intent/tweet?url='+encodeURI(baseUrl+window.location.search)+'&original_referer='+baseUrl+window.location.search,'', 'width=600, height=400')
  },
  render: function() {
    return(
      <div className="social-icons">
        <h2><i className="fa fa-share-alt"></i> Share</h2>
        <div className='embed'>
            <VideoLink/>
        </div>
      </div>
    )
  }
})

module.exports = Share



// WEBPACK FOOTER //
// ./src/components/Share.jsx